import { SearchAssetRequest, SearchAssetResultExternal } from '@askporter/client-grieg-lyric';
import { API } from './api';

export default async ({ payload }: { payload: SearchAssetRequest }): Promise<SearchAssetResultExternal> => {
  const { data } = await API().post({ path: 'assets/search', payload });
  return data;
};
